<template>
  <div class="main-wrap">
    <el-tabs v-model="activeName">
      <el-tab-pane name="gzzs">
        <span slot="label">公证证书</span>
        <safeguard-table :current-name="activeName" />
      </el-tab-pane>
      <el-tab-pane name="gzbgh">
        <span slot="label">保管函</span>
      <baoguanhan-table :current-name="activeName" />
      </el-tab-pane>
      <el-tab-pane name="ezj">
        <span slot="label">E证据</span>
        <eevidence-table :current-name="activeName" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import SafeguardTable from "@/components/order/safeguardTable";
import EevidenceTable from "@/components/order/eevidenceTable";
import BaoguanhanTable from "@/components/order/baoguanhanTable"
export default {
  components: {
    SafeguardTable,
    EevidenceTable,
BaoguanhanTable
  },
  data() {
    return {
      activeName: "gzzs",
    };
  },
  beforeMount() {
    this.$nextTick(() => {
      if (this.$route.query.orderType == 3) {
        this.activeName = "ezj";
      } else if (this.$route.query.orderType == 2) {
        this.activeName = "gzbgh";
      } else {
        this.activeName = "gzzs";
      }
    });
  },
};
</script>


<style lang="less" scoped>
.main-wrap {
   min-height: calc(100vh - 200px);
padding: 0;
    border-radius:2px;
    background: #ffffff;
    /deep/ .el-tabs__header{
      padding-top: 10px;
    }
    /deep/ .el-tabs__content{
      padding: 30px 20px;
    }

    /deep/ .el-tabs__item{
      color:rgba(41,2,2,1);
      &.is-active{
        font-weight: bold;
      }
      span{
        padding: 0 15px;
      }
    }

    /deep/ .el-table__body-wrapper {
      overflow-y: auto;
    }
}

.main-wrap /deep/ .el-tabs__item.is-active {
	color: #f10e0e;
}
.main-wrap /deep/ .el-tabs__active-bar {
	background-color: #f10e0e;
}
.main-wrap /deep/ .el-form-item { margin-bottom: 10px; }


</style>




// WEBPACK FOOTER //
// pages/console/order.vue